import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AppService, Modal, IncidentTypes, CoreProxyService, StringDateTimePipe, CoreTypes, ColorPickerService } from 'common-cloudstudio';
import moment from 'moment';
import { GearAppService } from 'common-gear';
import { Subscription } from 'rxjs';
import { IncidentService } from '../../services/incident.service';
import { CustomTableComponent } from 'src/app/shared/custom-table/custom-table.component';

@Component({
  selector: 'app-incidents',
  templateUrl: './incidents.component.html',
  styleUrls: ['./incidents.component.scss']
})
export class IncidentsComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('incidentModal') private _incidentModal: Modal;
  @ViewChild('incidentTable') private _incidentTable: CustomTableComponent;

  @Input() enableSelectedRows: boolean = false;
  @Input() enableRowActions: boolean = true;
  @Input() enableUpdateFilterButton: boolean = true;
  @Input() enableDisplayFilter: boolean = true;
  @Input() paramsFilter: any = null;

  @Output() onSelectedIncident = new EventEmitter<any>();

  incidentID: number = 0;
  _params: any[] = [
    {
      "AllowedValues": null,
      "Hidden": false,
      "Mandatory": true,
      "MultiSelectLiterals": null,
      "ParameterID": 3,
      "ParameterType": 1,
      "Prompt": "ID Evento",
      "RefreshOnChange": false,
      "UniqueParameterID": null,
      "ValueCheck": false,
      "ValueDateEnd": null,
      "ValueDateEndExpression": null,
      "ValueDateStart": null,
      "ValueDateStartExpression": null,
      "ValueMultiString": null,
      "ValueNumber": '',
      "ValueString": null
    },
    {
      "AllowedValues": null,
      "Hidden": false,
      "Mandatory": true,
      "MultiSelectLiterals": null,
      "ParameterID": 3,
      "ParameterType": 1,
      "Prompt": "Correlativo",
      "RefreshOnChange": false,
      "UniqueParameterID": null,
      "ValueCheck": false,
      "ValueDateEnd": null,
      "ValueDateEndExpression": null,
      "ValueDateStart": null,
      "ValueDateStartExpression": null,
      "ValueMultiString": null,
      "ValueNumber": '',
      "ValueString": null
    },
    {
      "AllowedValues": null,
      "Hidden": false,
      "Mandatory": true,
      "MultiSelectLiterals": null,
      "ParameterID": 1,
      "ParameterType": 9,
      "Prompt": "Período",
      "RefreshOnChange": false,
      "UniqueParameterID": null,
      "ValueCheck": false,
      "ValueDateEnd": {
        "Date": {
          "Day": 12,
          "Month": 7,
          "Year": 2024
        },
        "Time": {
          "Hour": 22,
          "Millisecond": 0,
          "Minute": 33,
          "Second": 22
        }
      },
      "ValueDateEndExpression": "",
      "ValueDateStart": {
        "Date": {
          "Day": 11,
          "Month": 7,
          "Year": 2024
        },
        "Time": {
          "Hour": 0,
          "Millisecond": 0,
          "Minute": 0,
          "Second": 0
        }
      },
      "ValueDateStartExpression": "",
      "ValueMultiString": null,
      "ValueNumber": 0,
      "ValueString": null
    },
    {
      "AllowedValues": [
        {
          "Name": "Accidente",
          "Value": "1041"
        },
        {
          "Name": "Asistencia",
          "Value": "1042"
        }
      ],
      "Hidden": false,
      "Mandatory": true,
      "MultiSelectLiterals": {
        "All": "Todos",
        "Find": "Buscar",
        "None": "Ninguno",
        "X_Selected": "seleccionadas"
      },
      "ParameterID": 1,
      "ParameterType": 5,
      "Prompt": "Tipo Eventos",
      "RefreshOnChange": false,
      "UniqueParameterID": null,
      "ValueCheck": false,
      "ValueDateEnd": null,
      "ValueDateEndExpression": null,
      "ValueDateStart": null,
      "ValueDateStartExpression": null,
      "ValueMultiString": [
        "1041", "1042"
      ],
      "ValueNumber": 0,
      "ValueString": null
    },
    {
      "AllowedValues": [
        {
          "Name": "Choque",
          "Value": "1041"
        },
        {
          "Name": "Colisión",
          "Value": "1042"
        }
      ],
      "Hidden": false,
      "Mandatory": true,
      "MultiSelectLiterals": {
        "All": "Todos",
        "Find": "Buscar",
        "None": "Ninguno",
        "X_Selected": "seleccionadas"
      },
      "ParameterID": 1,
      "ParameterType": 5,
      "Prompt": "Detalle Eventos",
      "RefreshOnChange": false,
      "UniqueParameterID": null,
      "ValueCheck": false,
      "ValueDateEnd": null,
      "ValueDateEndExpression": null,
      "ValueDateStart": null,
      "ValueDateStartExpression": null,
      "ValueMultiString": [
        "1041", "1042"
      ],
      "ValueNumber": 0,
      "ValueString": null
    },
    {
      "AllowedValues": null,
      "Hidden": false,
      "Mandatory": true,
      "MultiSelectLiterals": null,
      "ParameterID": 9996,
      "ParameterType": 7,
      "Prompt": "Incluir Borrados",
      "RefreshOnChange": true,
      "UniqueParameterID": null,
      "ValueCheck": false,
      "ValueDateEnd": null,
      "ValueDateEndExpression": null,
      "ValueDateStart": null,
      "ValueDateStartExpression": null,
      "ValueMultiString": null,
      "ValueNumber": 0,
      "ValueString": null
    }
  ]

  columnsConfig = [
    { Title: 'ID', Field: 'IncidentID', Type: 'text', Width: 50 },
    { Title: 'Correlativo', Field: 'MonthlyID', Alignment: 2, Type: 'text' },
    { Title: 'Fecha y Hora', Field: 'DateTimeCreated', Type: 'text', Alignment: 2},
    { Title: 'Evento', Field: 'IncidentType', Type: 'text', Alignment: 2 },
    { Title: 'Detalle Evento', Field: 'IncidentSubType', Type: 'text', Alignment: 2},
    { Title: 'Eje', Field: 'VialAxis',Type: 'text' },
    { Title: 'Vía', Field: 'Roadway',Type: 'text' },
    { Title: 'Calzada', Field: 'TrafficDirection',Type: 'text' },
    { Title: 'PK', Field: 'PK',Type: 'text' },
    { Title: 'Asistencia', Field: 'Assistance',Type: 'text' },
    {
      Title: '',
      Type: 'actions',
      Field: 'Actions',
      Actions: [
        {
          Icon: 'fa-solid fa-magnifying-glass',
          Tooltip: 'Ver Detalles',
          callback: (row: any) => this.onEdit(row.IncidentID)
        },
        {
          Icon: 'fa fa-ambulance',
          Tooltip: 'Ver Ficha',
          callback: (row: any) => this.onViewEmergencySheet(row.IncidentID)
        }
      ]
    },
  ];
  tableConfig: {
    Columns: any[],
    Elements: any[]
  };
  _errorMessage: string = "";
  modalOpen: boolean = false;
  activeTab: number = 1;
  incidentElements: IncidentTypes.IncidentElementModal;
  incidentManagementTypes = IncidentTypes.IncidentManagementType;
  loadIncidentData = 0;
  _facilityID: number = 0;
  subscriptions: Subscription[] = [];
  incidentFullList: CoreTypes.ITS_DetailedIncident = new CoreTypes.ITS_DetailedIncident();
  incidentSelected: any;

  constructor(
    public _appService: AppService,
    private cdRef: ChangeDetectorRef,
    private _gearService: GearAppService,
    private _coreProxyService: CoreProxyService,
    private stringDateTimePipe: StringDateTimePipe,
    private incidentService: IncidentService,
    private colorService: ColorPickerService,
  ) {}

  ngOnInit(): void {
    this.tableConfig = this.generateDynamicTableWithActions(this.columnsConfig, []);
    this.getIncidents();
    this._facilityID = this._appService.getFacilityID();
    this.subscriptions.push(this._gearService.onChangeFacilityID.subscribe(facilityID => {
      if (this._facilityID === facilityID) { return; }
      this._facilityID = this._appService.getFacilityID();
      this.tableConfig = null;
      this.getIncidents();
    }));

    this.subscriptions.push(this.incidentService.onRefreshIncidentList.subscribe(refresh => {
      if(refresh) {
        this.getIncidents();
      }
    }))
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
  
  ngOnChanges(data: SimpleChanges): void {
    if(data.paramsFilter.currentValue){
      this._params = this.paramsFilter;
    }
  }

  onViewEmergencySheet(row) {
    this.activeTab = 2;
    this.incidentID = row;
    this.incidentElements = {
      IncidentElementTypeID: this.incidentManagementTypes.IncidentFile,
      JsonData: '',
      Editing: false,
      IncidentID: this.incidentID
    };
    this.cdRef.detectChanges();
    this._incidentModal.open(this.incidentElements);
  }

  onEdit(id) {
    this.incidentID = id;
    this.incidentElements = {
      IncidentElementTypeID: this.incidentManagementTypes.Incidents,
      JsonData: '',
      Editing: true,
      IncidentID: this.incidentID
    }
    this.cdRef.detectChanges();
    this._incidentModal.open(this.incidentElements);
  }

  saveDataElements(event) {
    console.log(event);

  }

  onCloseSettings(event) {
    setTimeout(() => this.incidentElements = null, 100);
  }

  getIncidents() {
    this.loadIncidentData = 1;
    if(this.tableConfig?.Elements?.length) this.tableConfig.Elements = [];
    this._coreProxyService.IncidentService.EnumClientOpenedITSIncidents(
      this._appService.getAccessToken(),
      this._appService.getClientID(),
      this._appService.getFacilityID(),
      24,
      data => {
        this.tableConfig = this.generateDynamicTableWithActions(this.columnsConfig, data);
        this.loadIncidentData = 0;
      },
      err => {
        this._appService.showException(err);
        this.loadIncidentData = 2;
      }
    )
  }

  getIncidentWithActions(serviceData: CoreTypes.ITS_DetailedIncident, enableRowActions?:boolean):  any[]{
    if (!serviceData.Incident?.length || !serviceData.ReferencePoint) { return []; }

    return serviceData.Incident.map((incident) => {
      const reference = serviceData.ReferencePoint.find(rp => rp.ReferencePointID === incident.ReferencePoint.ReferencePointID);
      const incidentType = serviceData.IncidentType.find(t => t.Type.IncidentTypeID == incident.Incident.TypeID);
      const subType = incidentType?.SubTypes.find(s => s.IncidentSubTypeID === incident.Incident.SubTypeID);
      const findColor = serviceData.Color?.find(c => c.ColorID === incident.Incident.ColorID)?.ColorCode;
      const incidentColor = findColor ? this.colorService.rgbToHexa((findColor)) : null;
      const roadway =  serviceData.Roadway.find(d => d.RoadwayID === reference?.RoadwayID);
      const vialAxes = serviceData.Axis.find(v => v.VialAxisID === roadway?.VialAxisID);
      const trafficDirection = serviceData.TrafficDirection.find(t => t.DirectionID ===  reference?.DirectionID);
      const assitanceType = serviceData.IncidentAssistanceType.find(b => b.IncidentID === incident.Incident.IncidentID);
      const assistance =  serviceData.AssistanceType.find(a => a.AssistanceTypeID === assitanceType?.AssistanceTypeID);
      return {
        ElementId: incident.Incident.IncidentID,
        IncidentID: incident.Incident.IncidentID,
        MonthlyID: incident.Incident.MonthlyID,
        DateTimeCreated: moment(this.stringDateTimePipe.transform(incident.Incident.DateTimeCreated)).format('DD-MM-YYYY HH:mm'),
        IncidentType: incidentType?.Type?.Description || 'Sin determinar',
        IncidentSubType: subType?.Description || 'Sin determinar',
        VialAxis: vialAxes?.VialAxisName,
        Roadway: roadway?.RoadwayName,
        TrafficDirection: trafficDirection?.DirectionName,
        PK: reference?.KilometerPoint,
        Assistance: assistance?.AssistanceTypeName,
        Actions: !enableRowActions ? [] : [
          {
            Icon: 'fa-solid fa-magnifying-glass',
            Tooltip: 'Ver Detalles',
            Action: () => this.onEdit(incident.Incident.IncidentID)
          },
          {
            Icon: 'fa fa-ambulance',
            Tooltip: 'Ver Ficha',
            Action: () => this.onViewEmergencySheet(incident.Incident.IncidentID)
          }
        ],
        RowStyle: { backgroundColor: incidentColor }

      };
    });
  }

  generateDynamicTableWithActions(columnsConfig: any[], data: any): any {
    return {
      Columns: columnsConfig.map(col => ({
        Title: col.Title,
        Field: col.Field,
        Type: col.Type,
        Alignment: col.Alignment || 0,
        WidthPixels: col.Width || 100
      })),
      Elements: this.getIncidentWithActions(data, this.enableRowActions)
    };
  }

  getRowStyle(element: any): any {
    return {
      backgroundColor: element.ColorID === 8 ? '#28ca65' : '#eba11e'
    };
  }

  updateMonthlyIds(){

  }

  onRowSelected(event) {
    this.incidentSelected = this.tableConfig?.Elements?.find(x => x.ElementId === event);
    this.onSelectedIncident.emit(this.incidentSelected);
  }

  onCleanSelectedRow() {
    this.incidentSelected = null;
    this._incidentTable.cleanRowSelected();
  }
}
